import React from "react";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const DateRangePicker = ({ onChange, ...rest }) => {
  const handleChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      dates = [dates[0].startOf("day"), dates[1].endOf("day")];
    }
    if (onChange) onChange(dates, dateStrings);
  };

  return <RangePicker onChange={handleChange} {...rest} />;
};

export default DateRangePicker;
